import React, {useState} from 'react';
import PropTypes from 'prop-types';
import Button from './Button';
import styled from 'styled-components';
import {theme} from '../lib/theme';

const StyledGraphColor = styled.div`
  width: calc(100% - 32px);
  max-width: 500px;
  border-radius: 10px;
  background-color: #fff;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 8;
  padding: 0 20px 20px 20px;
  text-align: left;
  box-shadow: 0 0 10px 0 rgba(51, 51, 51, .15);
  height: auto;
  > div {
    width: 100%;
    float: left;

    &:first-child {
      h2 {
        font-family:'Helvetica Neue LT W01_35 Thin';
        font-size: 2em;
        padding-right: 70px;
      }
      span {
        font-size: .625em;
        color: #999;
        text-transform: uppercase;
      }
      > button {
        position: absolute;
        right: 20px;
        top: 36px;
        display: block;
        font-size: 1em;
        span {
          line-height: 1.4;
          vertical-align: top;
          display: none;
          @media (min-width: 640px) {
            display: block;
          }
        }
        i {
          margin: 2px 0 0 1em;
          width: 10px;
          height: 10px;
          float: right;
          svg {
            stroke: #000;
            stroke-width: 2;
          }
        }
      }
    }

    &:nth-child(2) {
      > div {
        display: flex;
        justify-content: space-between;
        margin: 1em 0;
        button {
          position: relative;
          display: flex-item;
          width: 34px;
          height: 34px;
          border: 5px solid white;
          box-shadow: 0 0 10px 0 rgba(51,51,51,0.15);
          i {
            margin: 0 auto;
            cursor: pointer;
            height: 100%;
            width: 100%;
            > svg {
              transform: rotate(45deg);
              width: 100%;
              fill: #fff;
              stroke-width: 2;
              line {
                stroke-linecap: square;
              }
            }
          }
        }
        @media (min-width: 400px) {
          button {
            width: 40px;
            height: 40px;
            border: 6px solid white;
            i {
              > svg {
                stroke-width: 3;
              }
            }
          }
        }
        @media (min-width: 520px) {
          button {
            width: 60px;
            height: 60px;
            border: 10px solid white;
            i {
              height: 18px;
              width: 18px;
              > svg {
                stroke-width: 4;
              }
            }
          }
        }
      }
    }

    &:last-child {
      button {
        width: 220px;
        height: 40px;
        justify-content: center;
        margin: 2em auto;
      }
    }
  }
`;

export default function GraphColor (props) {
  const {toggleLayer, toggleColor, product} = props;
  const {name} = product || {};
  const [selected, setSelected] = useState(product.color);
  const colorsFull = [theme.blueDark, theme.blueBright, theme.greenDark, theme.greenBright, theme.orange, theme.red];
  const colorsHalf = [theme.blueDarkHalf, theme.blueBrightHalf, theme.greenDarkHalf, theme.greenBrightHalf, theme.orangeHalf, theme.redHalf];
  return (
    <StyledGraphColor>
      <div>
        <h2>{name}</h2>
        <span>choose graph color</span>
        <Button icon="close" label="close" transparent onClick={toggleLayer}/>
      </div>
      <div>
        <div>
          {colorsFull.map((item, index) =>
            <Button round
              key={index}
              bg={item}
              icon={selected === item ? "plus" : null}
              onClick={() => setSelected(selected === item ? null : item)}
            />
          )}
        </div>
        <div>
          {colorsHalf.map((item, index) =>
            <Button round
              key={index}
              bg={item}
              icon={selected === item ? "plus" : null}
              onClick={() => setSelected(selected === item ? null : item)}
            />
          )}
        </div>
      </div>
      <div>
        <Button label="Apply" rounded blueBright onClick={() => toggleColor(selected)}/>
      </div>
    </StyledGraphColor>
  )
}

GraphColor.propTypes = {
  toggleLayer: PropTypes.func,
  setProductColor: PropTypes.func,
  product: PropTypes.object,
  visible: PropTypes.bool,
};
